<svelte:head>
  <title>Request | A Good Thing</title>
</svelte:head>

{#if data}
<div class="block is-size-7"><a href={$url(`../../offer/${data.offer}/${isMatched ? 'matches' : 'requests'}`)}> &lt; Back to offer</a></div>
{/if}

<RequestDetails {requestId} />

<script lang="ts">
  export let requestId :RequestId;
  import RequestDetails from '../offer/[id]/_components/RequestDetails.svelte';
  import { url } from "@sveltech/routify";

  let data : Request_v2;

  let firebase = window.firebase;

  $: isMatched = data && (data.status == 'selected' || data.status == 'interested' || data.status == 'matched' || data.status == 'completed' || data.status == 'failed')

  get();

  function get() {
    firebase
      .firestore()
      .collection("requests_v2")
      .doc(requestId)
      .onSnapshot((doc) => {
        data = doc.data() as Request_v2;
      });
  }

</script>
